// Human-readable labels for member_donations.recurring_status values, shared
// by the inbox member panel and the members table. Model-free so it stays
// importable from frontend code.
export const RECURRING_STATUS_LABELS: Record<string, string> = {
  active: 'Active recurring donor',
  lapsed: 'Lapsed recurring donor'
}

export function formatRecurringStatusLabel(
  status: string | null | undefined
): string | null {
  if (!status) return null
  return RECURRING_STATUS_LABELS[status] ?? status
}
